import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableHead } from '@mui/material';
import { currencyFormat } from '../../../utils/number';
import { dateFormat } from '../../../utils/date';
import GenericTablePaginationActions from '../../../component/generic/GenericTablePaginationActions';

const columns = [
    { id: 'idUnidade', label: 'ID Unidade', minWidth: 80 },
    { id: 'idPedido', label: 'ID Pedido', minWidth: 100 },
    { id: 'dataSaidaEntrada', label: 'Data & hora', minWidth: 100 },
    { id: 'tipoPedido', label: 'Tipo pedido', minWidth: 100 },
    { id: 'tipoPedidoDescricao', label: 'Canal', minWidth: 100 },
    { id: 'idPessoa', label: 'ID Pessoa', minWidth: 100 },
    { id: 'nome', label: 'Nome', minWidth: 200 },
    { id: 'valorTotal', label: 'Valor total', minWidth: 100, align: 'right' },
]

export default function ListSales({ data }) {

    // console.log('KpiTable', data)

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data?.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        // <Card>
        <TableContainer elevation={0} component={Paper}>
            <Table stickyHeader >
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {(rowsPerPage > 0
                        ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : data
                    ).map((row) => (
                        <TableRow key={row.idPedido}>
                            <TableCell  >
                                {row.idUnidade}
                            </TableCell>
                            <TableCell align="left">
                                {row.idPedido}
                            </TableCell>
                            <TableCell align="left">
                                {dateFormat(row.dataSaidaEntrada)}
                            </TableCell>
                            <TableCell align="left">
                                {row.tipoPedido}
                            </TableCell>
                            <TableCell align="left">
                                {row.tipoPedidoDescricao}
                            </TableCell>
                            <TableCell component="th" align="left">
                                {row.idPessoa}
                            </TableCell>
                            <TableCell align="left">
                                {row.nome}
                            </TableCell>
                            <TableCell align="right">
                                {currencyFormat(row.valorTotal, { simbol: '' })}
                            </TableCell>
                        </TableRow>
                    ))}
                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={8} />
                        </TableRow>
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, { label: 'Todos', value: -1 }]}
                            colSpan={8}
                            count={data?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelRowsPerPage='linhas por página'
                            SelectProps={{
                                inputProps: {
                                    'aria-label': 'linhas por página',
                                },
                                native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={GenericTablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
        // </Card>
    )
}